module.exports = __webpack_public_path__ + "static/media/Note_Background.e3675246.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/quotation-request/Note_Background.jpg
// module id = 1631
// module chunks = 0